<!--page starts-->
<section class="page-wrapper">
	<div class="ashton-hero-top-clubsponsorship" *ngIf=" bannerplayerList?.type == 'Image'" [ngStyle]="{'background-image':'url(' + bannerplayerList?.image + ')'}">
		<div class="container">
		   <div class="ashton-hero-top-clubsponsorship-detail">
				  <!--<h2>{{bannerplayerList?.title}}</h2>-->
		   </div> 	
		</div>
		<div class="ashton-hero-top-clubsponsorship-overlay"></div>
	</div>
	<div class="ashton-hero-top-clubsponsorship-section cf">
		<div class="container">
			<div class="ashton-hero-top-clubsponsorship-section-detail the-cross-bar cf">
				
				<div class="ashton-clubsponsorship-bottom" *ngIf="hospitalityList.length > 0">
					<div class="ashton-matchday-detail" *ngFor="let hospital of hospitalityList">
						<div class="ashton-matchday-content" >
							<h2>{{hospital?.title}}</h2>
							<!-- <div [innerHTML]="hospital?.description" class="list"></div> -->
                            <div class="list" [innerHTML]="hospital?.description">
                                <!-- <h3>Package for 10 people  includes: </h3> -->
                                <!--<p>A Match Sponsorship is a great way to entertain clients, family or friends and enjoy the ambience and hospitality of one of Britain’s oldest football clubs. A Match Sponsorship is a great way to entertain clients, family or friends and enjoy the ambience and hospitality of one of Britain’s oldest football clubs. </p>-->
                                
                            </div>
                            <div class="the-cross-bar-detail-btn">
                                <ul>
                                    <li *ngIf="hospital?.btn_title_1 != ''"><a href="{{hospital?.btn_url_1}}" class="">{{hospital?.btn_title_1}}</a></li>
                                    <li *ngIf="hospital?.btn_title_2 != ''"><a href="{{hospital?.btn_url_2}}" class="">{{hospital?.btn_title_2}}</a></li>
                                </ul>
                            </div>
							
						</div>
						<div class="ashton-matchday-image" >
							<img [src]="hospital?.image">
						</div>
					</div>
				</div>
			</div>
			<div class="our-charity-detail cf">
				<div class="our-charity-left">
					<h3>OUR CHARITY</h3>
					<p>ASHTON UNITED IN COMMUNITY</p>
					<div class="our-charity-left-btn">
						<a href="https://www.auitc.co.uk/" target="_blank" class="seemore-white">Know More</a>
					</div>
				</div>
				<div class="our-charity-right">
					<img src="assets/images/Bitmap-icon.png" alt="Bitmap-icon">
				</div>
			</div>
		</div>
	</div>
</section><!-- page ends -->